import { tz } from '@date-fns/tz'
import { differenceInCalendarDays } from 'date-fns'

/**
 * Calendar days from the show's start day to `time`, counted in `timezone`.
 * The inverse of `getHardStartTime`: the day offset a cue starting at `time`
 * carries as `startDatePlus`.
 *
 * @param time - when the cue starts
 * @param options.showStart - the show start the day offset counts from
 * @param options.timezone - IANA timezone the days are counted in, UTC when unset
 */
export function getStartDatePlus(
  time: Date,
  { showStart, timezone }: { showStart: Date; timezone?: string | null },
): number {
  return differenceInCalendarDays(time, showStart, { in: tz(timezone ?? 'UTC') })
}
